export function communityFilters() {
	const stateFilter = document.getElementById('state-filter');
	const careFilter = document.getElementById('care-filter');
	if (!stateFilter || !careFilter) return;

	const cards = document.querySelectorAll('.community-list-card[data-state]');
	const listing = document.querySelector('.community-listing');

	// Create and insert "no results" message (hidden by default)
	const noResults = document.createElement('p');
	noResults.className = 'community-listing__no-results';
	noResults.textContent = 'No communities match your filters.';
	noResults.hidden = true;
	listing.after(noResults);

	function applyFilters() {
		const state = stateFilter.value;
		const care = careFilter.value;
		let visibleCount = 0;

		// Filter list cards
		cards.forEach((card) => {
			const matchState = !state || card.dataset.state === state;
			const matchCare = !care || card.dataset.care.split(',').includes(care);
			const show = matchState && matchCare;
			card.style.display = show ? '' : 'none';
			if (show) visibleCount++;
		});

		noResults.hidden = visibleCount > 0;

		// Map marker sync — disabled for now, uncomment to re-enable
		// const mapData = window._communityMap;
		// if (!mapData) return;
		//
		// const visibleMarkers = [];
		// mapData.markerLayer.eachLayer((marker) => {
		//   const d = marker._data;
		//   const matchState = !state || d.state === state;
		//   const matchCare = !care || d.care.includes(care);
		//   if (matchState && matchCare) {
		//     marker.setOpacity(1);
		//     marker.getElement().style.pointerEvents = '';
		//     visibleMarkers.push(marker);
		//   } else {
		//     marker.setOpacity(0);
		//     marker.getElement().style.pointerEvents = 'none';
		//     marker.closePopup();
		//   }
		// });
		//
		// if (visibleMarkers.length > 0) {
		//   const group = L.featureGroup(visibleMarkers);
		//   mapData.map.fitBounds(group.getBounds().pad(0.15));
		// }
	}

	stateFilter.addEventListener('change', applyFilters);
	careFilter.addEventListener('change', applyFilters);
}
